<template>
  <div id="index-practice-exam-list">
    <!-- 模拟考试列表 -->
    <div class="top">
      <div class="goback" @click="goback" style="margin-top: 0">
        <i class="el-icon-d-arrow-left"></i>返回
      </div>
      <div class="add_but" @click="startExam">
        <i class="iconfont icon-kaoshizhongxinoff"></i>开始考试
      </div>
    </div>
    <div class="content" v-if="list.length > 0">
      <div
        class="item"
        v-for="(item, index) in list"
        :key="index"
        @click="showExamDetails(item)"
      >
        <i class="iconfont icon-a-kaoshi6"></i>
        <div class="title">{{ item.name }}</div>
        <div class="li">模拟时间:{{ item.startTime }}</div>
        <div class="li">考试时长:{{ item.duration }}分钟</div>
        <div class="li">
          得分:<span>{{ item.score }}</span
          >分
        </div>
      </div>
    </div>
    <div class="content" v-else>
      <diy_nothing :tip="'暂无考试记录!!!'"></diy_nothing>
    </div>

    <diy_dialog
      v-if="dialogData.flag"
      :title="dialogData.title"
      :width="dialogData.width"
      :dialogData="dialogData.dialogData"
      :buttonList="dialogData.buttonList"
      @colseDialog="colseDialog"
      @dialogOper="dialogOper"
    ></diy_dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      list: [
        {
          name: "模拟考试1",
          startTime: "2023-07-01 15:30:00",
          duration: "15",
          score: 120,
        },
      ],
      dialogData: {
        flag: false,
        title: "选择模拟考试的科目",
        width: "40%",
        tempData: {},
        dialogData: [],
        buttonList: [
          { text: "确定", active: "makesure_choose_subject" },
          { text: "取消", active: "cancel" },
        ],
      },
    };
  },
  methods: {
    /**
     * 获取当前学员参与的所有模拟考试
     */
    async getImitateExamList() {
      try {
        let resultData = await this.$request({
          url: "/imitateExam/getImitateExamList",
          method: "post",
          data: {},
        });
        this.list = resultData;
      } catch (error) {
        this.$message.error(error.message);
      }
    },
    /**
     * 开始考试
     */
    async startExam() {
      try {
        let resultData = await this.$request({
          url: "/subjects/getAllSubjectForSelect",
          method: "post",
          data: {},
        });
        let subject = [];
        resultData.forEach((element) => {
          let dd = {
            label: element.name,
            value: element.id,
          };
          subject.push(dd);
        });
        this.dialogData.dialogData = [
          {
            title: "模拟科目",
            key: "subject",
            value: [],
            type: "select-object",
            options: subject,
            placeholder: "请选择要模拟的科目",
          },
        ];
        this.dialogData.flag = true;
      } catch (error) {
        this.$message.error(error.message);
      }
    },
    /**
     * 查看具体模拟考试详情
     */
    showExamDetails(item) {
      this.$router.push({
        path: "/practice/exam-testing",
        query: {
          id: item.id,
          flag: "1",
        },
      });
    },
    /**
     * 弹出框操作事件
     */
    dialogOper(active) {
      try {
        switch (active) {
          case "cancel":
            this.colseDialog();
            break;
          case "makesure_choose_subject":
            // 确定选择科目进行模拟考试
            let queryData = {
              id: "",
              flag: "0",
            };
            queryData = this.$baseData.array2json(
              this.dialogData.dialogData,
              queryData
            );
            this.$router.push({
              path: "/practice/exam-testing",
              query: queryData,
            });
            break;

          default:
            break;
        }
      } catch (error) {}
    },
    /**
     * 关闭弹出框
     */
    colseDialog() {
      this.dialogData.flag = false;
    },
    /**
     * 返回上一页
     */
    goback() {
      this.$router.back();
    },
  },
  async mounted() {
    await this.getImitateExamList();
  },
};
</script>

<style lang="less" scoped>
#index-practice-exam-list {
  width: 100%;
  height: 100%;
  display: flex;
  padding: 10px 15px;
  box-sizing: border-box;
  flex-direction: column;
  > .top {
    width: 100%;
    height: 70px;
    margin-bottom: 10px;
    background-color: #fff;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  > .content {
    width: 100%;
    height: 0;
    flex: 1;
    overflow-y: auto;
    display: flex;
    flex-wrap: wrap;
    background-color: #fff;
    padding: 10px;
    box-sizing: border-box;
    align-content: flex-start;
    > .item {
      width: 210px;
      height: 240px;
      background-color: #e4e8eb5e;
      margin: 6px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      transition: 0.3s;
      border: 1.5px solid #ffffff00;
      box-sizing: border-box;
      border-radius: 5px;
      box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04);
      > i {
        font-size: 45px;
        color: #afafaf;
        margin-bottom: 10px;
      }
      > .title {
        width: 100%;
        margin-bottom: 5px;
        font-size: 15px;
        font-weight: bold;
      }
      > .li {
        font-size: 13px;
        margin-bottom: 5px;
        > span {
          color: #51c939;
          margin: 0 3px;
        }
      }
      &:hover {
        border-color: @baseColor;
        // color: #ff7b00;
        background-color: #53535333;
        i {
          // color: #ff7b00;
        }
      }
    }
  }
  > .page {
    width: 100%;
    height: 70px;
    margin-top: 10px;
    background-color: #fff;
  }
}
</style>